import { Flex } from "rebass";
import { getLocalizedString } from "../../../utils";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
const LineBlock = ({
  openLine,
  showLineOptions,
  lineOptions,
  selectFilterLineOptions,
}) => {
  return (
    <>
      <Flex
        bg="#DEDEDE"
        height="40px"
        width="100%"
        style={{ borderBottom: "2px solid #d2d2d2" }}
        px="10px"
        alignItems="center"
        justifyContent="space-between"
        onClick={openLine}
      >
        <span>{getLocalizedString("Linea").toUpperCase()}</span>
        <div>{showLineOptions ? <BsChevronUp /> : <BsChevronDown />}</div>
      </Flex>
      <Flex flexDirection="column">
        {showLineOptions &&
          lineOptions?.map((opt, i) => (
            <Flex
              key={i}
              height="40px"
              px="10px"
              alignItems="center"
              bg="#f2f2f2"
              mb="2px"
              onClick={() => selectFilterLineOptions(opt)}
            >
              <span>{opt.label}</span>
            </Flex>
          ))}
      </Flex>
    </>
  );
};

export { LineBlock };
